export default {
    /**
     * @property {string} apiKey - API key for the TomTom maps API.
     * @property {string} momaKey - API key for the TomTom MOMA API.
     */
    apiKey: null,
    momaKey: null,
};
